import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	CreateEstimateButton,
	ExitButton,
	PackingSlipControl,
	PrintButton,
	RequestCancellationButton,
	RetailOrderCommunicationButton,
	RetailOrderFilesButton,
	RetailOrderInformationCards,
	RetailOrderPage,
	RetailOrderProgress,
	RetailOrderReportType
} from '../../../features/cfi/retail-order';
import '../../../css/order.scss';

export default function PackingSlipPage() {

	return (
		<RetailOrderPage>

			<RetailOrderInformationCards />

			<RetailOrderProgress />

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<PrintButton reportType={RetailOrderReportType.Info} />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<RetailOrderCommunicationButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<RetailOrderFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<CreateEstimateButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<RequestCancellationButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
			</Toolbar>

			<div className='dx-card wide-card'>
				<PackingSlipControl />
			</div>

		</RetailOrderPage>
	)
}
